/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "//s.geilicdn.com/customer/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(759);
	
	var dWin = document.getElementById("d_win");
	var dMac = document.getElementById("d_mac");
	var baseUrl = 'https://assets.geilicdn.com/im/desktop/download';
	
	// 调整为 spider 上报方式
	window.spiderReport = {
	  paq: function (actionName) {
	    if (window.spider) {
	      window.spider.trackAction({
	        actionName: actionName
	      });
	    }
	  }
	};
	
	window.spider && spider.trackPageview();
	
	dWin.addEventListener("click", function () {
	  spiderReport.paq("桌面版im下载页-windows下载点击");
	});
	
	dMac.addEventListener("click", function () {
	  spiderReport.paq("桌面版im下载页-mac下载点击");
	});
	
	window.getversion = function (data) {
	  dWin.setAttribute("href", baseUrl + "/wd-chat-" + data.version.win + "-win.exe?t=v" + data.version.win);
	  dMac.setAttribute("href", baseUrl + "/wd-chat-" + data.version.mac + "-mac.dmg?t=v" + data.version.mac);
	
	  //判断 url 是否有自动下，
	  if (window.location.search.indexOf('download') >= 0) {
	
	    if (window.location.search.indexOf('darwin') >= 0) {
	      dMac.click();
	    } else {
	      dWin.click();
	    }
	  }
	};
	
	function getDownloadUrl() {
	  var script = document.createElement("script");
	  script.setAttribute("src", "https://s.geilicdn.com/entry/version.json?t=v1.0.380");
	  document.body.appendChild(script);
	}
	
	getDownloadUrl();

/***/ },

/***/ 759:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }

/******/ });


/** WEBPACK FOOTER **
 ** 0d7e95.down.js
 **/